import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key:'reports.city',
  path: '/reports/customer-city',
  title: 'Customer by City',
  component: dynamicWrapper(app,[import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);